import React from "react";

export default function SectionTitle({ eyebrow, title, desc }) {
  return (
    <div className="mx-auto max-w-3xl text-center">
      {eyebrow ? (
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-red">
          {eyebrow}
        </div>
      ) : null}

      <h2 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl">
        {title}
      </h2>

      {desc ? <p className="mt-3 text-white/65">{desc}</p> : null}
    </div>
  );
}
